var map = {
	"./avchd.svg": "e04b",
	"./avi.svg": "f15b",
	"./common-doc.svg": "3721",
	"./csv.svg": "a6ea",
	"./doc-icon.svg": "7590",
	"./doc-lock-icon.svg": "fc4f",
	"./doc.svg": "eddd",
	"./docx.svg": "1ba4",
	"./flv.svg": "e8ad",
	"./gif.svg": "69f9",
	"./html.svg": "08fa",
	"./jpeg.svg": "bbd6",
	"./jpg.svg": "cd83",
	"./key.svg": "05fa",
	"./m4a.svg": "28a0",
	"./mkv.svg": "4565",
	"./mov.svg": "32a9",
	"./mp3.svg": "2bae",
	"./mp4.svg": "351d",
	"./odp.svg": "35bf",
	"./pdf.svg": "7fca",
	"./png.svg": "c743",
	"./ppt.svg": "b16b",
	"./pptx.svg": "21d3",
	"./protected-icon.svg": "9c89",
	"./svg.svg": "1858",
	"./tif.svg": "e845",
	"./txt.svg": "ed47",
	"./warning.svg": "d6fc",
	"./wav.svg": "d15d",
	"./webm.svg": "aac2",
	"./xls.svg": "b0cc",
	"./xlsx.svg": "27a0",
	"./zip-icon.svg": "2dac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c73";